export default {
  'Watermark': 'Watermerk',
  'Add Watermark Selection': 'Watermerk toevoegen Selectie',
}